import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {
    IOrderScheduleWorking
} from "../../../../../../../utils/interfaces/tannery_production/order_schedule/IOrderScheduleWorking";


const useApiGetWorkingsOrdersByOrder = (
    companyToken: string | undefined, order_id: number | undefined
): UseQueryResult<IOrderScheduleWorking[], CustomAxiosError> => {

    const {get} = useApiCalls();

    async function doGet(company_token: string | undefined, order_id: number | undefined): Promise<IOrderScheduleWorking[]> {
        try {
            const response = await get(`/api/company/${company_token}/tannery_production/workings/${order_id}/order_id`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }


    return useQuery({
        queryKey: ["getWorkingOrdersByOrder", order_id],
        queryFn: () => doGet(companyToken, order_id),
        enabled: !!order_id
    })
};

export default useApiGetWorkingsOrdersByOrder